<template>
  <template v-if="view==='listar'">
    <button
      v-if="data['valor_actual'] > 0.00"
      @click="customUpdateActions?.map(async (action) => await action());$emit('updateValues', { view: 'cargar_caps', selectedData: data })"
      class="flex items-center px-4 py-1 text-white bg-orange-600 rounded-md hover:bg-red-600 focus:outline-none"
      title="Agregar CAPS" style="width: 150px;">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a3 3 0 013-3h10a3 3 0 013 3v14a3 3 0 01-3 3H7a3 3 0 01-3-3V5z"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V9"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 14h10"></path>
      </svg>
      <span class="ml-2">Agregar CAP</span>
    </button>


    <button v-if="data['caps'].length > 0" 
    @click="customUpdateActions?.map(async action => await action());$emit('updateValues', {'view': 'ver_caps', 'selectedData': data})"
            class="flex items-center px-2 py-1 text-white bg-green-600 rounded-md hover:bg-green-600 focus:outline-none"  
            title="Ver CAPS" style="width: 110px;">
            👁 
            <span class="ml-2">Ver CAP</span>
    </button>
    
  </template>
</template>
<script>
export default {
  name: 'PasivoExigibleChildTableComponent',
  props: ['view', 'data', 'listApi','queries', 'customListData', 
   'customUpdateSelectedData','collectionTipoCAP', 'selectedData','loadData', 'customUpdateCollectionData','customCreateActions', 
  'customUpdateActions'],
  emits: ['updateValues'],

};
</script>